import React from "react";

const FacilitiesManagement:React.FC = () =>{
    return(
        <></>
    )
}
export default FacilitiesManagement;